export default __webpack_public_path__ + "media/monsters/01-0619d281.png";